import {
  pickemCreateGroupPath,
  pickemJoinGroupPath,
  pickemUserPath,
} from "pages/PageConfigs";
import { useNavigate } from "react-router-dom";
import { selectUid } from "selectors/User";
import { FlexColumn } from "styles/layout";
import { GroupsList } from "./GroupsList";
import { GroupsButton, ButtonContainer } from "./styles";
import { useAppSelector } from "app/hooks";

export const PickemGroups = () => {
  const navigate = useNavigate();
  const uid = useAppSelector(selectUid);
  const toCreateGroup = () => {
    navigate(pickemCreateGroupPath);
  };

  const toJoinGroup = () => {
    navigate(pickemJoinGroupPath);
  };

  const toUserPicks = () => {
    navigate(`${pickemUserPath}/${uid}`);
  };

  return (
    <FlexColumn>
      <GroupsList />
      <ButtonContainer>
        <GroupsButton onClick={toCreateGroup}>Create Group</GroupsButton>
        <GroupsButton onClick={toJoinGroup}>Join Group</GroupsButton>
        {!!uid && (
          <GroupsButton style={{ width: "140px" }} onClick={toUserPicks}>
            View Your Picks
          </GroupsButton>
        )}
      </ButtonContainer>
    </FlexColumn>
  );
};
